import DOMPurify from 'dompurify';

/**
 * HTML that is safe to put in dangerouslySetInnerHTML.
 *
 * Text that reaches these renders can come from public ingest (a span output
 * in a dataset row only needs a site_id to send) or from another team member
 * (a board's text card, which public dashboard links also show). Until Oct
 * 2026 both were rendered raw, so `<img src=x onerror=…>` ran in the viewer's
 * session, with their access token in localStorage.
 *
 * DOMPurify strips scripts, event handlers and javascript: URLs. On top of
 * that: no iframes, objects, forms or inputs, no <style> (CSS can exfiltrate
 * and restyle the app), and no images (a remote image is a beacon that tells
 * a sender who opened their row, and when). Links keep target and get
 * rel="noopener noreferrer".
 */
const FORBID_TAGS = ['style', 'img', 'iframe', 'frame', 'object', 'embed', 'form', 'input', 'button', 'textarea', 'select', 'link', 'meta', 'base', 'svg', 'math'];

let hooked = false;
function ensureHooks() {
  if (hooked) return;
  hooked = true;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target')) {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

export function sanitizeHtml(html) {
  ensureHooks();
  return DOMPurify.sanitize(String(html ?? ''), {
    ADD_ATTR: ['target'],
    FORBID_TAGS,
    FORBID_ATTR: ['style', 'srcset', 'formaction'],
  });
}

export default sanitizeHtml;
